import { type Command } from "prosemirror-state";

import { handleArrowDownInComputeCell } from "./handleArrowDownInComputeCell";

export const handleArrowRightInComputeCell: Command = handleArrowDownInComputeCell;
